"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var L1_1 = __importDefault(require("./L1"));
var L2_1 = __importDefault(require("./L2"));
var L3_1 = __importDefault(require("./L3"));
function FilterMenu(props) {
  var _a = props.type,
    type = _a === void 0 ? 'L3' : _a,
    restProps = __rest(props, ["type"]);
  if (type === 'L1') {
    return react_1.default.createElement(L1_1.default, __assign({}, restProps));
  } else if (type === 'L2') {
    return react_1.default.createElement(L2_1.default, __assign({}, restProps));
  } else {
    return react_1.default.createElement(L3_1.default, __assign({}, restProps));
  }
}
exports.default = FilterMenu;